import { render } from "./LeadFormBlock.vue?vue&type=template&id=a96c525e&ts=true"
import script from "./LeadFormBlock.vue?vue&type=script&lang=ts"
export * from "./LeadFormBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__